import { Set } from 'immutable';
import memoize from 'lodash/memoize';

import { onInfiniteScroll, onRandomAccessInfiniteScroll } from '../actions/InfiniteScroll';

function getOnRandomAccessInfiniteScrollAction(
  items: $TSFixMe,
  originalItems: $TSFixMe,
  dataFetcher: $TSFixMe,
  fetchingOffsets: $TSFixMe,
  apiLimit: $TSFixMe,
  totalCount: $TSFixMe,
  loadedPages: $TSFixMe,
  { firstVisibleIndex, lastVisibleIndex }: $TSFixMe,
): $TSFixMe {
  return onRandomAccessInfiniteScroll({
    items,
    originalItems,
    firstVisibleIndex,
    lastVisibleIndex,
    dataFetcher,
    fetchingOffsets,
    apiLimit,
    totalCount,
    loadedPages,
  });
}

function getOnInfiniteScrollAction(
  items: $TSFixMe,
  dataFetcher: $TSFixMe,
  hasFetchedData: $TSFixMe,
  listItemTotal: $TSFixMe,
  pageSize: $TSFixMe,
  { forceFetch }: $TSFixMe,
): $TSFixMe {
  return onInfiniteScroll({
    items,
    dataFetcher,
    hasFetchedData,
    pageSize,
    listItemTotal,
    forceFetch,
  });
}

// Note: viewIdentifier should rely on all parameters that getDataFetcher is memoized with
export const getOnRandomAccessInfiniteScroll = memoize(
  (
    _viewIdentifier,
    loadedPages,
    fetchingOffsets = Set(),
    items,
    originalItems,
    dataFetcher,
    apiLimit,
    totalCount,
  ) => {
    return getOnRandomAccessInfiniteScrollAction.bind(
      null,
      items,
      originalItems,
      dataFetcher,
      fetchingOffsets,
      apiLimit,
      totalCount,
      loadedPages,
    );
  },
  (viewIdentifier, loadedPages, fetchingOffsets = Set()) => {
    return `${viewIdentifier}:${loadedPages.join(',')}:${fetchingOffsets.join(',')}`;
  },
);

export const getOnInfiniteScroll = memoize(
  (_viewIdentifier, items, dataFetcher, hasFetchedData, listItemTotal, pageSize) => {
    return getOnInfiniteScrollAction.bind(
      null,
      items,
      dataFetcher,
      hasFetchedData,
      listItemTotal,
      pageSize,
    );
  },
  (viewIdentifier, items, _dataFetcher, hasFetchedData, listItemTotal, pageSize) => {
    return `${viewIdentifier}:${items.length}:${hasFetchedData}:${listItemTotal}:${pageSize}`;
  },
);

// Note: memoFunc and apiCallFunc must accept the exact same arguments in the same order
export const getDataFetcher = memoize(
  (_memoFunc, apiCallFunc, ...args) => {
    return apiCallFunc.bind(null, ...args);
  },
  (memoFunc, _apiCallFunc, ...args) => memoFunc(...args),
);

export function clearGetOnInfiniteScrollCache(): void {
  if (getOnRandomAccessInfiniteScroll) {
    getOnRandomAccessInfiniteScroll?.cache?.clear?.();
  }
  if (getOnInfiniteScroll) {
    getOnInfiniteScroll?.cache?.clear?.();
  }
  if (getDataFetcher) {
    getDataFetcher?.cache?.clear?.();
  }
}
